import { render, staticRenderFns } from "./KlasusLevel5.vue?vue&type=template&id=142eff64&scoped=true"
import script from "./KlasusLevel5.vue?vue&type=script&lang=js"
export * from "./KlasusLevel5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142eff64",
  null
  
)

export default component.exports